
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { PvcWindowContent } from "@components/pvc-window-content";
import { NextSeo } from "@components/seo";
import { ALU } from "@consts/aalu";
import type { IProduct } from "@type/products";
import { getAllAluByParent, getAllAluPathsById, getAluById, getProductLocaleRedirect, } from "@utils/get-products";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next/types";
interface IProductCard {
    product: IProduct;
    products: IProduct[];
}
const AluprofPage: NextPage<IProductCard> = ({ product, products }) => (<>
    <NextSeo title={product?.title}/>
    <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
      <PvcWindowContent product={product}/>
      {products && <Products productPage products={products} showId/>}
    </div>
  </>);
export const getStaticPaths: GetStaticPaths = async () => {
    const PATHS_IDS = Object.values(ALU.SLIDING_DOORS.ALUPROF);
    const { paths: path } = await getAllAluPathsById(PATHS_IDS);
    const paths = path.map((p: {
        slug: string;
        databaseId: string;
        language: {
            code: string;
        };
    }) => ({
        locale: p.language.code.toLowerCase(),
        params: {
            slug: `${p.slug}-${p.databaseId}`,
        },
    }));
    return {
        fallback: "blocking",
        paths,
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PRODUCT_ID = slug.split("-").pop();
    const { product } = await getAluById(PRODUCT_ID, LOCALE);
    if (!product) {
        return { notFound: true };
    }
    const redirect = getProductLocaleRedirect(product, LOCALE, "/alu/sliding-doors/aluprof");
    if (redirect) {
        return { redirect };
    }
    const { products } = await getAllAluByParent(ALU.SLIDING_DOORS.ALUPROF[LOCALE as keyof typeof ALU.SLIDING_DOORS.ALUPROF], LOCALE);
    return {
        props: {
            product,
            products,
        },
    };
};
export default AluprofPage;

    async function __Next_Translate__getStaticProps__1a19cd2bff0__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alu/sliding-doors/aluprof/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bff0__ as getStaticProps }
  